var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_Mobile",
    "data-name": "Download/Mobile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 0.05,
    x2: -0.383,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 0.5,
    x2: -1.305,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.863,
    y1: 0.178,
    x2: -0.501,
    y2: 1.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: -0.541,
    x2: 0.421,
    y2: 0.249,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Download_Mobile_style_",
    "data-name": "Download/Mobile (style)",
    width: 162,
    height: 48,
    rx: 7,
    fill: "#141416"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_615E1330-1278-40F5-934E-1CE2288188BA",
    "data-name": "615E1330-1278-40F5-934E-1CE2288188BA",
    d: "M5.123,0A5.031,5.031,0,0,0,0,5.1a5.042,5.042,0,0,0,5.123,5.1,5.042,5.042,0,0,0,5.124-5.1A5.033,5.033,0,0,0,5.123,0Z",
    transform: "translate(76.64 26.102)",
    fill: "#fcfcfd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A48EE100-5314-42E2-93A0-AAC6BA0961DB",
    d: "M2.88,6.187A2.952,2.952,0,0,1,0,3.094,2.941,2.941,0,0,1,2.88,0,2.94,2.94,0,0,1,5.76,3.094,2.953,2.953,0,0,1,2.88,6.187Z",
    transform: "translate(78.883 28.112)",
    fill: "#141416"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_92ED113C-B3DA-4CAF-80C2-DAD33D3E7BE7",
    "data-name": "92ED113C-B3DA-4CAF-80C2-DAD33D3E7BE7",
    d: "M5.123,0A5.031,5.031,0,0,0,0,5.1a5.042,5.042,0,0,0,5.123,5.1,5.042,5.042,0,0,0,5.124-5.1A5.031,5.031,0,0,0,5.123,0Z",
    transform: "translate(65.464 26.102)",
    fill: "#fcfcfd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_3F693D31-937C-4563-85EE-959381A23292",
    "data-name": "3F693D31-937C-4563-85EE-959381A23292",
    d: "M2.88,6.187A2.952,2.952,0,0,1,0,3.094,2.941,2.941,0,0,1,2.88,0,2.94,2.94,0,0,1,5.76,3.094,2.952,2.952,0,0,1,2.88,6.187Z",
    transform: "translate(67.707 28.112)",
    fill: "#141416"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_57732E07-737D-4893-81EB-6CB2BD53F383",
    "data-name": "57732E07-737D-4893-81EB-6CB2BD53F383",
    d: "M8.042,7.212V9.377h5.182a4.512,4.512,0,0,1-1.18,2.725,5.3,5.3,0,0,1-4,1.585A5.685,5.685,0,0,1,2.359,7.926,5.685,5.685,0,0,1,8.042,2.165a5.52,5.52,0,0,1,3.9,1.547l1.528-1.528A7.554,7.554,0,0,0,8.042,0,8.037,8.037,0,0,0,0,7.926a8.037,8.037,0,0,0,8.042,7.926,7.246,7.246,0,0,0,5.528-2.224,7.156,7.156,0,0,0,1.876-5.065,7,7,0,0,0-.116-1.352H8.042Z",
    transform: "translate(49.25 20.457)",
    fill: "#fcfcfd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "_296550F6-A6F5-4E89-98B4-B7509E53A4E7",
    "data-name": "296550F6-A6F5-4E89-98B4-B7509E53A4E7",
    d: "M9.184,3.248A4.744,4.744,0,0,0,4.814,0,4.851,4.851,0,0,0,0,5.1a5,5,0,0,0,5.065,5.1A5.08,5.08,0,0,0,9.319,7.945l-1.74-1.16A2.915,2.915,0,0,1,5.065,8.2,2.6,2.6,0,0,1,2.591,6.649L9.415,3.827Z",
    transform: "translate(102.479 26.102)",
    fill: "#fcfcfd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "_98F045E9-28B5-445D-81C5-E6C0AD3EC976",
    "data-name": "98F045E9-28B5-445D-81C5-E6C0AD3EC976",
    d: "M0,2.977A2.8,2.8,0,0,1,2.67,0,1.979,1.979,0,0,1,4.565,1.082Z",
    transform: "translate(104.701 28.074)",
    fill: "#141416"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "_6598CDBB-D637-42F9-BE1D-5D4C6E42D432",
    "data-name": "6598CDBB-D637-42F9-BE1D-5D4C6E42D432",
    d: "M0,15H2.242V0H0Z",
    transform: "translate(99.155 20.999)",
    fill: "#fcfcfd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "FC5DCDC4-0A47-4E44-A509-3A4DDCDF2271",
    d: "M7.655,1.141H7.578A3.536,3.536,0,0,0,4.891,0,5.076,5.076,0,0,0,0,5.124a5.054,5.054,0,0,0,4.891,5.084A3.48,3.48,0,0,0,7.578,9.049h.077v.734c0,1.952-1.044,3-2.725,3a2.824,2.824,0,0,1-2.572-1.817l-1.952.812A4.864,4.864,0,0,0,4.93,14.791c2.629,0,4.853-1.547,4.853-5.317V.311H7.656v.83Z",
    transform: "translate(87.826 26.102)",
    fill: "#fcfcfd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "_447D50E2-312D-468D-9D56-62042A123AAC",
    "data-name": "447D50E2-312D-468D-9D56-62042A123AAC",
    d: "M2.842,6.187A2.929,2.929,0,0,1,0,3.113,2.951,2.951,0,0,1,2.842,0,2.876,2.876,0,0,1,5.567,3.113,2.853,2.853,0,0,1,2.842,6.187Z",
    transform: "translate(90.068 28.112)",
    fill: "#141416"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "_3CC37AAF-2D91-4654-ABBE-32C88E845B2E",
    "data-name": "3CC37AAF-2D91-4654-ABBE-32C88E845B2E",
    d: "M5.365,0H0V15H2.238V9.318H5.364A4.754,4.754,0,0,0,10.286,4.66,4.754,4.754,0,0,0,5.365,0Z",
    transform: "translate(116.802 20.999)",
    fill: "#fcfcfd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "_7890D9D2-E566-4518-AF3E-0A5EC1C59C05",
    "data-name": "7890D9D2-E566-4518-AF3E-0A5EC1C59C05",
    d: "M3.185,5.142H0V0H3.185A2.6,2.6,0,0,1,5.809,2.572,2.613,2.613,0,0,1,3.185,5.142Z",
    transform: "translate(119.04 23.087)",
    fill: "#141416"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "_2322764D-5EE5-46A9-AB53-4F6F8BDFFBD2",
    "data-name": "2322764D-5EE5-46A9-AB53-4F6F8BDFFBD2",
    d: "M4.266,0A4.2,4.2,0,0,0,.271,2.3l1.987.829A2.124,2.124,0,0,1,4.3,2.026a2.156,2.156,0,0,1,2.354,1.93V4.11a4.957,4.957,0,0,0-2.335-.578C2.182,3.532,0,4.709,0,6.908a3.466,3.466,0,0,0,3.725,3.3A3.157,3.157,0,0,0,6.581,8.741h.077V9.9H8.82V4.147C8.821,1.486,6.832,0,4.266,0Z",
    transform: "translate(131.797 26.075)",
    fill: "#fcfcfd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "_72BD1106-C74F-4A94-ACBB-D9481787204E",
    "data-name": "72BD1106-C74F-4A94-ACBB-D9481787204E",
    d: "M1.756,2.876C1.024,2.876,0,2.509,0,1.6,0,.444,1.274,0,2.375,0A3.99,3.99,0,0,1,4.42.5,2.715,2.715,0,0,1,1.756,2.876Z",
    transform: "translate(134.036 31.42)",
    fill: "#141416"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "B26D07CA-95CA-4ABB-A0D0-7C7E25883DDE",
    d: "M7.72,0,5.153,6.5H5.076L2.412,0H0L3.995,9.09,1.717,14.147H4.052L10.209,0Z",
    transform: "translate(140.772 26.402)",
    fill: "#fcfcfd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "_1F9CAC5A-FAEB-4296-86D8-27BD85D6421F",
    "data-name": "1F9CAC5A-FAEB-4296-86D8-27BD85D6421F",
    d: "M0,15H2.238V0H0Z",
    transform: "translate(128.324 20.999)",
    fill: "#fcfcfd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "_94055EB9-6B61-44B2-AB4B-88079E16398F",
    "data-name": "94055EB9-6B61-44B2-AB4B-88079E16398F",
    d: "M7.279,4.051a3.25,3.25,0,0,1-.894,2.4A3.49,3.49,0,0,1,3.74,7.52a3.624,3.624,0,0,1-2.65-1.08A3.623,3.623,0,0,1,0,3.761a3.619,3.619,0,0,1,1.091-2.68A3.62,3.62,0,0,1,3.74,0,3.717,3.717,0,0,1,5.218.3a2.963,2.963,0,0,1,1.126.8l-.632.634A2.429,2.429,0,0,0,3.739.884,2.782,2.782,0,0,0,.943,3.76a2.782,2.782,0,0,0,2.8,2.875,2.729,2.729,0,0,0,2.011-.8,2.267,2.267,0,0,0,.6-1.458H3.739V3.508H7.228A2.887,2.887,0,0,1,7.279,4.051Z",
    transform: "translate(49.623 8.24)",
    fill: "#fcfcfd",
    stroke: "#fcfcfd",
    strokeWidth: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "_839AB386-AA0A-441A-AFFC-FF6858FA2C4E",
    "data-name": "839AB386-AA0A-441A-AFFC-FF6858FA2C4E",
    d: "M4.2.884H.925V3.167H3.882v.865H.925V6.314H4.2V7.2H0V0H4.2Z",
    transform: "translate(58.23 8.4)",
    fill: "#fcfcfd",
    stroke: "#fcfcfd",
    strokeWidth: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "_092FA2C2-2F72-4F77-B406-75F0624C2F5D",
    "data-name": "092FA2C2-2F72-4F77-B406-75F0624C2F5D",
    d: "M2.936,7.2H2.011V.884H0V0H4.948V.884H2.936Z",
    transform: "translate(63.952 8.4)",
    fill: "#fcfcfd",
    stroke: "#fcfcfd",
    strokeWidth: 1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "EB9B40D6-74C4-48CD-9066-AA950A2C9281",
    d: "M0,7.2V0H.925V7.2Z",
    transform: "translate(71.926 8.4)",
    fill: "#fcfcfd",
    stroke: "#fcfcfd",
    strokeWidth: 1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "A6E0C086-8E43-472B-800B-845EF8EDF29D",
    d: "M2.936,7.2H2.011V.884H0V0H4.948V.884H2.936Z",
    transform: "translate(74.369 8.4)",
    fill: "#fcfcfd",
    stroke: "#fcfcfd",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_71E1AD08-28FB-463A-92B9-655B3AD8B0AD",
    "data-name": "71E1AD08-28FB-463A-92B9-655B3AD8B0AD",
    transform: "translate(81.991 8.238)",
    fill: "#141416"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.699599981307983 6.772799968719482 C 2.850620031356812 6.772799968719482 2.163390159606934 6.490339756011963 1.598620057106018 5.9092698097229 C 1.027440071105957 5.3225998878479 0.7500000596046448 4.620369911193848 0.7500000596046448 3.76200008392334 C 0.7500000596046448 2.903630018234253 1.027440071105957 2.2014000415802 1.598180055618286 1.615190029144287 C 2.164170026779175 1.032860040664673 2.851410150527954 0.75 3.699599981307983 0.75 C 4.542150020599365 0.75 5.228219985961914 1.034440040588379 5.797019958496094 1.619570016860962 C 6.371260166168213 2.210299968719482 6.650400161743164 2.911089897155762 6.650400161743164 3.76200008392334 C 6.650400161743164 4.619369983673096 6.372809886932373 5.321750164031982 5.801780223846436 5.9092698097229 C 5.236199855804443 6.490190029144287 4.548419952392578 6.772799968719482 3.699599981307983 6.772799968719482 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.699599981307983 6.022799968719482 C 4.344250202178955 6.022799968719482 4.841609954833984 5.820330142974854 5.263959884643555 5.386529922485352 C 5.698170185089111 4.939799785614014 5.900400161743164 4.423590183258057 5.900400161743164 3.76200008392334 C 5.900400161743164 3.106990098953247 5.696670055389404 2.592329978942871 5.259230136871338 2.142339944839478 C 4.833230018615723 1.704110026359558 4.337650299072266 1.5 3.699599981307983 1.5 C 3.055850028991699 1.5 2.559149980545044 1.702559947967529 2.135550022125244 2.13838005065918 C 1.701950073242188 2.583739995956421 1.50000011920929 3.09965991973877 1.50000011920929 3.76200008392334 C 1.50000011920929 4.424339771270752 1.701950073242188 4.94025993347168 2.13644003868103 5.386529922485352 C 2.558350086212158 5.820620059967041 3.055060148239136 6.022799968719482 3.699599981307983 6.022799968719482 M 3.699599981307983 7.522799968719482 C 2.647200107574463 7.522799968719482 1.767600059509277 7.159200191497803 1.060800075531006 6.432000160217285 C 0.3528000712394714 5.704800128936768 8.087157965519509e-08 4.814400196075439 8.087157965519509e-08 3.76200008392334 C 8.087157965519509e-08 2.70959997177124 0.3528000712394714 1.819200038909912 1.060800075531006 1.092000007629395 C 1.767600059509277 0.364799976348877 2.647200107574463 -1.564025886580112e-08 3.699599981307983 -1.564025886580112e-08 C 4.746000289916992 -1.564025886580112e-08 5.62440013885498 0.3659999966621399 6.334800243377686 1.096799969673157 C 7.045199871063232 1.827600002288818 7.400400161743164 2.71560001373291 7.400400161743164 3.76200008392334 C 7.400400161743164 4.814400196075439 7.04640007019043 5.704800128936768 6.339600086212158 6.432000160217285 C 5.631599903106689 7.159200191497803 4.751999855041504 7.522799968719482 3.699599981307983 7.522799968719482 Z",
    stroke: "none",
    fill: "#fcfcfd"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "_9234E5DB-D039-4099-9A1C-B473962665DF",
    "data-name": "9234E5DB-D039-4099-9A1C-B473962665DF",
    d: "M0,7.2V0H1.126l3.5,5.6h.04l-.04-1.387V0H5.55V7.2H4.584L.923,1.327H.883l.04,1.387V7.2Z",
    transform: "translate(90.69 8.4)",
    fill: "#fcfcfd",
    stroke: "#fcfcfd",
    strokeWidth: 1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.556.088A2.4,2.4,0,0,0,0,1.774V28.313A2.4,2.4,0,0,0,.556,30l.089.086L15.511,15.218v-.35L.644,0Z",
    transform: "translate(11.968 8.958)",
    fill: "url(#linear-gradient)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.955,10.264,0,5.306v-.35L4.956,0l.112.064L10.939,3.4c1.676.953,1.676,2.512,0,3.466L5.068,10.2Z",
    transform: "translate(27.479 18.87)",
    fill: "url(#linear-gradient-2)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M20.023,5.069,14.954,0,0,14.956a1.952,1.952,0,0,0,2.494.074Z",
    transform: "translate(12.523 24.001)",
    fill: "url(#linear-gradient-3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M20.023,10.363,2.494.4A1.951,1.951,0,0,0,0,.478L14.956,15.433Z",
    transform: "translate(12.523 8.569)",
    fill: "url(#linear-gradient-4)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreButton);
export default __webpack_public_path__ + "static/media/playStoreButton.bbd7aae3c4fe98ae311bda447618ac83.svg";
export { ForwardRef as ReactComponent };